export const environment = {
    production: false,
    auth0: {
        domain: 'rendelo-tirex.eu.auth0.com',
        clientId: 'AZM7b3lBAquZGNXkY5NwQyeeCoGNU26I',
        authorizationParams: {
            audience: 'https://rendelo.tirex.hu/api/',
            redirect_uri: window.location.origin,
        },
    },
    errorPath: '/callback',
    apiUrl: 'https://rendelo-teszt.api.tirex.hu/api',
    paging: {
        defaultPageSize: 50,
    },
    debounceMs: 1000
};
